/**
 * Opening the login dialog from anywhere, with what it should show: an e-mail
 * already typed, a notice ("password set"), or the "forgot password" mode.
 * The dialog lives in the Header; pages ask for it through this event.
 */
export interface LoginIntent {
  email?: string
  notice?: string
  /** Why the person has to sign in again (the session ended under them); shown in amber, not as a success. */
  warning?: string
  mode?: 'password' | 'recovery'
}

export const LOGIN_INTENT_EVENT = 'memberfy:open-login'

export const openLoginWith = (intent: LoginIntent = {}) => {
  window.dispatchEvent(new CustomEvent<LoginIntent>(LOGIN_INTENT_EVENT, { detail: intent }))
}

/** Opening the signup dialog from a page (F-161a: "Entre ou cadastre-se", "Entrar na comunidade"). */
export const SIGNUP_INTENT_EVENT = 'memberfy:open-signup'

export const openSignup = () => {
  window.dispatchEvent(new CustomEvent(SIGNUP_INTENT_EVENT))
}
